<template>
  <transition mode="out-in">
    <router-view/>
  </transition>
</template>

<style lang="scss">
	@import "@/styles/index.scss";

	/* Remove in 1.2 */
	.v-datatable thead th.column.sortable i {
		vertical-align: unset;
  }
</style>
<script>
// checks to see if auth jwt token is valid or has expired, if it gets back 401 error log out
/** * silent refresh (IMPLEMENTED) vs interceptor (GOT ISSUE)
 * SILENT REFRESH scheme: (IMPLEMENTED)
 * 1. setInterval per (based on expires_in token) - 30s to 5mins before
 * 2. HTTP GET /refresh , client send Cookie, server will receive refresh_token from Cookie
 * 3. on success response: store the token in memory, get the cookie httpOnly for refresh_token
 * 4. go to step 1 again
 **/
/** INTERCEPTOR scheme (GOT ISSUE NO.4): CONCLUSION = It's not a GOOD METHOD to IMPLEMENT.
 * 1. When calling API but returned 403 but have token in memory (flag authorized variable), do NO.2
 * 2. Intercept calling HTTP GET /refreshtoken and  Store the token in memory again after success.
 * 3. client received refresh_token in cookie httpOnly
 * 4. GOT PROBLEM how to re-execute the XHR correctly
 */
/** CLOSE BROWSER PROBLEM: AUTO LOGOUT vs KEEP LOGGED IN?
 * A. AUTO LOGOUT --> We need to remove /refresh token when component created in VUE
 * B. KEEP LOGGED IN --> [IMPLEMENTED]
 *  1. when close browser all token gone in memory, but cookie still there! as well as LocalStorage, but token in LS can be expired
 *  2. calling HTTP GET /refresh when DOM load first time (VUEJS beforeCreated lifecycle), then store token in memory.
 *  3. no.2 will work because we use SPA and use cookie to store refresh_token
  */
/** [IMPLEMENTED FINISH] fallback when refresh_token invalid
 * 1. HTTP GET /refreshtoken returned error (401,403) or empty token, redirect to /logout (action: logout)
 *    or just LOGOUT
 * [SOLVED IN POINT B.2] open url in new tab ISSUE for Silent Refresh
 */
export default {
  created: function () {
    this.$http.interceptors.response.use((response) => {
      return response
    }, async (error) => {
      console.log(error)
      if (error.response.status === 401 || error.response.status === 403) {
        if (this.$store.getters.authorized) {
          // Interceptor SCHEME
          // await this.$store.dispatch('refreshtoken').then(window.location.reload)

          /* silent refresh SCHEME, we will remove this if using INTERCEPTOR SCHEME */
          await this.$store.dispatch('logout')
          await this.$router.push({ path: '/' })
        } else {
          return Promise.reject(error)
        }
      } else {
        return Promise.reject(error)
      }
    })
  }
}
</script>
